/**
 * Maska polskiego numeru: `+48` jest stałym prefiksem obok pola, a wpisuje się
 * dziewięć cyfr w grupach 3-3-3.
 *
 * Numer przychodzi z zaproszenia, więc człowiek najczęściej przepisuje go z SMS-a
 * albo wkleja. Wklejka bywa w dowolnej postaci — `+48 512 340 118`, `0048512340118`,
 * `512-340-118` — i każda z nich ma dać ten sam wynik.
 */

const NATIONAL_LENGTH = 9;

/** Wyciąga krajowe 9 cyfr z dowolnego zapisu. */
export function nationalDigits(input: string): string {
  let digits = (input || "").replace(/\D/g, "");

  // Kolejno: prefiks międzynarodowy 0048, kod kraju 48, zero międzymiastowe.
  if (digits.startsWith("0048")) digits = digits.slice(4);
  else if (digits.length > NATIONAL_LENGTH && digits.startsWith("48")) digits = digits.slice(2);
  if (digits.length > NATIONAL_LENGTH && digits.startsWith("0")) digits = digits.slice(1);

  return digits.slice(0, NATIONAL_LENGTH);
}

/** `512340118` → `512 340 118`. Grupy po trzy czyta się szybciej niż ciąg. */
export function formatNational(digits: string): string {
  return digits.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
}

/** Postać wysyłana do API. */
export function toE164(digits: string): string {
  return `+48${digits}`;
}

export function isComplete(digits: string): boolean {
  return digits.length === NATIONAL_LENGTH;
}

export const PHONE_PLACEHOLDER = "512 340 118";
export const PHONE_PREFIX = "+48";
export const PHONE_NATIONAL_LENGTH = NATIONAL_LENGTH;
